import { pairwise, startWith } from "rxjs/operators";
export function pairwiseStartWith(value) {
    return (source) => source.pipe(startWith(value), pairwise());
}
//# sourceMappingURL=pairwiseStartWith.js.map